import controller from './packet-delete-dialog.controller';

export default {
  controller,
  template: require('./packet-delete-dialog.html')
};



// WEBPACK FOOTER //
// src/app/packet/packet-delete-dialog/packet-delete-dialog.component.ts